// extracted by mini-css-extract-plugin
export default {"container":"debug-panel_container__QCi+A"};